import { Link } from "react-router-dom";
import LegalLayout, { LegalSection } from "./LegalLayout";
import { CONTROLLER, LEGAL } from "../../lib/legal";

export default function Terms() {
    return (
        <LegalLayout title="Termini e Condizioni" version={LEGAL.termsVersion} testid="terms-page">
            <LegalSection title="1. Oggetto">
                <p>
                    I presenti Termini e Condizioni regolano l&apos;accesso e l&apos;utilizzo della
                    piattaforma <strong>{CONTROLLER.product}</strong> (di seguito il
                    &ldquo;Servizio&rdquo;), fornita da <strong>{CONTROLLER.legalName}</strong>{" "}
                    (di seguito il &ldquo;Fornitore&rdquo;). L&apos;utilizzo del Servizio comporta
                    l&apos;accettazione integrale dei presenti Termini.
                </p>
            </LegalSection>

            <LegalSection title="2. Descrizione del Servizio">
                <p>
                    Il Servizio è una piattaforma SaaS che aggrega informazioni su aste immobiliari
                    giudiziarie da fonti pubbliche, ne effettua una pre-valutazione e produce analisi
                    assistite da intelligenza artificiale a scopo informativo e di supporto decisionale.
                    Il Servizio <strong>non</strong> costituisce attività di intermediazione immobiliare,
                    consulenza legale, finanziaria, fiscale o di investimento.
                </p>
            </LegalSection>

            <LegalSection title="3. Account e sicurezza">
                <p>
                    L&apos;utente è responsabile della veridicità dei dati forniti, della custodia delle
                    credenziali e di ogni attività svolta tramite il proprio account. È necessario avere
                    la capacità giuridica di agire e operare per finalità professionali.
                </p>
            </LegalSection>

            <LegalSection title="4. Natura dei dati e fonti">
                <p>
                    I dati sulle aste provengono da portali e fonti pubbliche e sono raccolti nel rispetto
                    dei relativi termini d&apos;uso e dei file robots.txt, con limiti di frequenza e senza
                    aggiramento di sistemi di autenticazione, paywall o anti-bot. Il Fornitore non
                    garantisce l&apos;esattezza, la completezza o l&apos;aggiornamento dei dati di terze
                    parti. L&apos;utente è tenuto a verificare sempre le informazioni presso le fonti
                    ufficiali (tribunale, perizia, avviso di vendita) prima di assumere qualsiasi
                    decisione.
                </p>
            </LegalSection>

            <LegalSection title="5. Analisi AI e limitazione di responsabilità">
                <p>
                    Le analisi, gli &ldquo;Investment Score&rdquo;, le stime di ROI e ogni altro output
                    generato dall&apos;intelligenza artificiale hanno natura <strong>meramente
                    indicativa e probabilistica</strong> e possono contenere errori o imprecisioni. Essi{" "}
                    <strong>non costituiscono consulenza</strong> professionale, legale, finanziaria,
                    fiscale o di investimento, né raccomandazione all&apos;acquisto. Si rinvia al{" "}
                    <Link to="/disclaimer-ai" className="underline">Disclaimer AI</Link>.
                </p>
                <p>
                    Nei limiti massimi consentiti dalla legge, il Fornitore non risponde di danni diretti
                    o indiretti, perdite economiche, mancati guadagni o decisioni assunte dall&apos;utente
                    sulla base degli output del Servizio. Le decisioni di partecipazione alle aste e di
                    investimento sono assunte dall&apos;utente in piena autonomia e sotto la propria
                    esclusiva responsabilità. Nulla nei presenti Termini esclude o limita la
                    responsabilità ove ciò non sia consentito dalla legge (es. dolo o colpa grave).
                </p>
            </LegalSection>

            <LegalSection title="6. Uso consentito">
                <p>
                    È vietato utilizzare il Servizio per finalità illecite, effettuare reverse
                    engineering, sovraccaricare l&apos;infrastruttura, rivendere o redistribuire i dati
                    senza autorizzazione, o violare diritti di terzi.
                </p>
            </LegalSection>

            <LegalSection title="7. Proprietà intellettuale">
                <p>
                    Il software, il marchio, l&apos;interfaccia e i contenuti originali del Servizio sono
                    di proprietà del Fornitore o dei rispettivi titolari. All&apos;utente è concessa una
                    licenza d&apos;uso personale, non esclusiva e non trasferibile, limitata alla durata
                    del rapporto.
                </p>
            </LegalSection>

            <LegalSection title="8. Sospensione e recesso">
                <p>
                    Il Fornitore può sospendere o limitare l&apos;accesso in caso di violazione dei
                    presenti Termini. L&apos;utente può recedere in qualsiasi momento cancellando
                    l&apos;account dall&apos;area <strong>Account</strong>, con conseguente cancellazione
                    dei dati nei termini indicati nella{" "}
                    <Link to="/privacy" className="underline">Privacy Policy</Link>.
                </p>
            </LegalSection>

            <LegalSection title="9. Modifiche">
                <p>
                    Il Fornitore può modificare i presenti Termini; le modifiche sostanziali saranno
                    comunicate e la versione vigente è sempre pubblicata su questa pagina.
                </p>
            </LegalSection>

            <LegalSection title="10. Legge applicabile e foro competente">
                <p>
                    I presenti Termini sono regolati dalla legge italiana. Per i rapporti con utenti
                    professionali è competente in via esclusiva il Foro di Firenze, salvo diversa norma
                    inderogabile a tutela del consumatore ove applicabile.
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
